// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.relative {
   position: relative;
}

iframe {
   border-collapse: collapse;
   border: none;
   width: 250px;
   height: 500px;
}
app-sign-pdftron {
   border-collapse: collapse;
   border: none;
   width: 250px;
   height: 500px;
}

::ng-deep .mat-dialog-content {
   max-height: 85vh;
}

body {
   overflow: hidden;
}

.text-viewer {
   border-collapse: collapse;
   border: none;
   width: 250px;
   height: 500px;
   overflow: auto;
   white-space: pre-wrap;
}

.img-center {
   display: flex; /*for IE*/
   /*display: -webkit-box;*/
   align-items: center;
   justify-content: center;
}

.image-viewer {
   overflow: auto;
   border-collapse: collapse;
   border: none;
   width: 250px;
   height: 500px;
   pointer-events: auto;
}
.image-viewer img {
   background: #fff;
   max-width: 100%;
   max-height: 100%;
}
.image-viewer::ng-deep svg {
   width: 100%;
}

audio {
   min-width: 80%;
   visibility: hidden;
}
.video-viewer {
   background-color: black;
   border-collapse: collapse;
   border: none;
   width: 250px;
   height: 500px;
}
video {
   max-width: 100%;
   max-height: 100%;
   visibility: hidden;
}

.visible {
   visibility: visible;
}

.can-not-preview {
   padding: 2em;
   text-align: center;
}

.preview-icon {
   opacity: .7;
   width: 160px;
   height: 160px;
   margin: auto;
}
.preview-error {
   color: #1b2733;
   font-size: 18px;
   margin: 8px;
}
.preview-error-info {
   color: #637282;
}
.preview-error-info span {
   margin: 0 8px;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/tasks/preview-document-dialog/preview-document-dialog.component.css"],"names":[],"mappings":"AAAA;GACG,kBAAkB;AACrB;;AAEA;GACG,yBAAyB;GACzB,YAAY;GACZ,YAAY;GACZ,aAAa;AAChB;AACA;GACG,yBAAyB;GACzB,YAAY;GACZ,YAAY;GACZ,aAAa;AAChB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,YAAY;GACZ,YAAY;GACZ,aAAa;GACb,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,aAAa,EAAE,SAAS;GACxB,wBAAwB;GACxB,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;GACG,cAAc;GACd,yBAAyB;GACzB,YAAY;GACZ,YAAY;GACZ,aAAa;GACb,oBAAoB;AACvB;AACA;GACG,gBAAgB;GAChB,eAAe;GACf,gBAAgB;AACnB;AACA;GACG,WAAW;AACd;;AAEA;GACG,cAAc;GACd,kBAAkB;AACrB;AACA;GACG,uBAAuB;GACvB,yBAAyB;GACzB,YAAY;GACZ,YAAY;GACZ,aAAa;AAChB;AACA;GACG,eAAe;GACf,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,YAAY;GACZ,kBAAkB;AACrB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,aAAa;GACb,YAAY;AACf;AACA;GACG,cAAc;GACd,eAAe;GACf,WAAW;AACd;AACA;GACG,cAAc;AACjB;AACA;GACG,aAAa;AAChB","sourcesContent":[".relative {\n   position: relative;\n}\n\niframe {\n   border-collapse: collapse;\n   border: none;\n   width: 250px;\n   height: 500px;\n}\napp-sign-pdftron {\n   border-collapse: collapse;\n   border: none;\n   width: 250px;\n   height: 500px;\n}\n\n::ng-deep .mat-dialog-content {\n   max-height: 85vh;\n}\n\nbody {\n   overflow: hidden;\n}\n\n.text-viewer {\n   border-collapse: collapse;\n   border: none;\n   width: 250px;\n   height: 500px;\n   overflow: auto;\n   white-space: pre-wrap;\n}\n\n.img-center {\n   display: flex; /*for IE*/\n   /*display: -webkit-box;*/\n   align-items: center;\n   justify-content: center;\n}\n\n.image-viewer {\n   overflow: auto;\n   border-collapse: collapse;\n   border: none;\n   width: 250px;\n   height: 500px;\n   pointer-events: auto;\n}\n.image-viewer img {\n   background: #fff;\n   max-width: 100%;\n   max-height: 100%;\n}\n.image-viewer::ng-deep svg {\n   width: 100%;\n}\n\naudio {\n   min-width: 80%;\n   visibility: hidden;\n}\n.video-viewer {\n   background-color: black;\n   border-collapse: collapse;\n   border: none;\n   width: 250px;\n   height: 500px;\n}\nvideo {\n   max-width: 100%;\n   max-height: 100%;\n   visibility: hidden;\n}\n\n.visible {\n   visibility: visible;\n}\n\n.can-not-preview {\n   padding: 2em;\n   text-align: center;\n}\n\n.preview-icon {\n   opacity: .7;\n   width: 160px;\n   height: 160px;\n   margin: auto;\n}\n.preview-error {\n   color: #1b2733;\n   font-size: 18px;\n   margin: 8px;\n}\n.preview-error-info {\n   color: #637282;\n}\n.preview-error-info span {\n   margin: 0 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
